/**
 * 医生排班模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 新增排班
export const scheduleAdd = (params) => {
  return req.post('/scheduling/item', params);
}

// 修改排班信息
export const scheduleEdit = (params) => {
  return req.put('/scheduling/item', params);
}

// 获取排班列表
export const scheduleList = (params) => {
  return req.get('/scheduling/item/list', params);
}

// 获取排班详情
export const scheduleInfo = (schedulingItemId) => {
  return req.get(`/scheduling/item/${schedulingItemId}`);
}

// 获取义诊排班列表
export const scheduleFreeList = (params) => {
  return req.get('/scheduling/item/free/list', params);
}

// 义诊放号时间设置
export const scheduleFreeTime = (params) => {
  return req.post('/scheduling/item/free', params);
}

// 取消义诊
export const freeCancel = (schedulingItemIds) => {
  return req.post(`/scheduling/item/cancelFree/${schedulingItemIds}`);
}

// 自动排班
export const automaticScheduling = (params) => {
  return req.post('/scheduling/item/automaticScheduling', params);
}

// 删除排班
export const delScheduling = (params) => {
  return req.post('/scheduling/item/remove', params)
}

//获取排班规则
export const getTimeRule = (params) => {
  return req.get('/scheduling/timeQuantum/getTimeRule', params)
}

//获取排班下时间段
export const getTimeQuantumList = (params) => {
  return req.get('/scheduling/timeQuantum/getTimeQuantumList', params)
}